import { render } from "./Synopsis.vue?vue&type=template&id=d8f71f4e&scoped=true"
import script from "./Synopsis.vue?vue&type=script&lang=js"
export * from "./Synopsis.vue?vue&type=script&lang=js"

import "./Synopsis.vue?vue&type=style&index=0&id=d8f71f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f71f4e"]])

export default __exports__